export default __webpack_public_path__ + "static/media/logo.665f9589.jpg";